import { defineComponent as _defineComponent } from 'vue'
import { alertProps } from './alert';


export default /*#__PURE__*/_defineComponent({
  __name: 'alert',
  props: alertProps,
  setup(__props) {

const props = __props



return { __sfc: true,props }
}

})